import React from "react";
import PropTypes from "prop-types";
import { Grid, Row, Col, Image } from "react-bootstrap";
import { FormattedMessage } from "react-intl";

import "./Willkommen.css";

const Willkommen = props => (
	<Grid>
		<Row>
			<Col xs={12}>
				<Image src="/willkommen.jpg" className="Willkommen-Image img-responsive"/>
			</Col>
		</Row>
		<Row>
			<Col xs={12}>
				<div className="Willkommen-Textblock">
					<h1><FormattedMessage id="Welcome at ALMiG" /></h1>
					{/* TODO: Versionen sind abhängig von der Steuerung */}
					<p><FormattedMessage id="Controller" />: {props.ablauf_version || "---"}</p>
				</div>
			</Col>
		</Row>
	</Grid>
);

Willkommen.propTypes = {
	ablauf_version: PropTypes.string,
	webcontrol_version: PropTypes.string
};

export default Willkommen;
